import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import {catchError, concatMap, map, switchMap, withLatestFrom} from 'rxjs/operators';
import {EMPTY, of} from 'rxjs';
import { FirmWareLogActionTypes, FirmWareLogActions } from '../actions/firm-ware-log.actions';
import * as fromStore from '../../../store';
import * as featureActions from '../../index';
import {FirmWareService} from '../../../services/firm-ware.service';
import {Store} from '@ngrx/store';
import {FirmWareLogParams} from '../firm-ware.model';


@Injectable()
export class FirmWareLogEffects {
  private actions$ = inject(Actions);
  private store$ = inject(Store<fromStore.State>);
  private firmWareService = inject(FirmWareService);

  constructor() {}

  getFirmWareLogs$ = createEffect(() => this.actions$.pipe(
    ofType(FirmWareLogActionTypes.GetFirmWareLogs),
    map((action: featureActions.GetFirmWareLogs) => action.payload),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([payload, user]) => {
      // NgRx 9 不可變性: 創建新對象副本
      const params = {
        ...payload,
        otp: user.otp,
        ...(user.authority < 1 && { acode: user.acode }) // Above of the admin could view all of upgrade records.
      };
      return this.firmWareService.ReadFirmwareLog(params).pipe(
        map((res) => {
          if (res.result && res.msg.body && Array.isArray(res.msg.body)) {
            return new featureActions.LoadFirmWareLogs(res.msg.body);
          } else {
            return new featureActions.GetFirmWareLogsFail();
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError(error => {
          return of(new featureActions.GetFirmWareLogsFail());
        })
      );
    })
  ));
  getFirmwareMgtLogs$ = createEffect(() => this.actions$.pipe(
    ofType(FirmWareLogActionTypes.GetFirmwareMgtLogs),
    map((action: featureActions.GetFirmwareMgtLogs) => action.payload),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([payload, user]) => {
      const param = {
        otp: user.otp,
        id_list: null,
        FWType: payload.FWType
      };
      if (payload.IdList && payload.IdList.length > 0) {
        param.id_list = payload.IdList;
      }
      return this.firmWareService.ReadFirmwareMgtLog(param).pipe(
        map((res) => {
          if (res.result && res.msg.body && Array.isArray(res.msg.body)) {
            return new featureActions.LoadFirmwareMgtLogs(res.msg.body);
          } else {
            return new featureActions.GetFirmwareMgtLogsFail();
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError(error => {
          return of(new featureActions.GetFirmwareMgtLogsFail());
        })
      );
    })
  ));


}
